<section id="secao-inscricoes-abertas">
  <div class="container">
    <div class="titulo-inscricoes-abertas">
      <h3>Inscrições Encerradas</h3>
    </div>
    <div class="paragrafo-inscricoes-abertas">
      <p>Prórximas inscrições do Projeto Educere serão feitas em 2026.</p>
    </div>
    <div class="area-inscricoes-abertas">
      <a target="_blank" role="button">
        <div class="parag-area-inscricoes-abertas">
          <p>Próximas inscrições em outubro de 2026</p>
        </div>
      </a>
    </div>
  </div>
</section>
